import { useLocation } from 'react-router-dom';

import { HorizontalContainer } from '@american-autonomy/ag-ui';

import OnboardingStepCount from 'components/OnboardingStepCount';
import TopBar from 'components/TopBar';
import TriangleArrowIcon from 'components/icons/TriangleArrowIcon';
import NavigationText from 'components/text/NavigationText';

import useLogout from 'hooks/useLogout';
import usePageRoutes from 'hooks/usePageRoutes';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const OnboardingTopBar: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => {
    const { onboardingCurrentUserPage } = usePageRoutes();
    const location = useLocation();

    const isCurrentUserStep = location.pathname === onboardingCurrentUserPage;

    const { LOG_OUT } = useTranslation();
    const { logout } = useLogout();

    return (
        <TopBar className={className} testId={testId}>
            <HorizontalContainer className={styles.wrapper} onClick={logout}>
                <TriangleArrowIcon className={styles.triangleArrowIcon} />

                <NavigationText className={styles.navigationText} text={LOG_OUT} />
            </HorizontalContainer>

            {isCurrentUserStep && <OnboardingStepCount className={styles.onboardingStepCount} />}
        </TopBar>
    );
};

export default OnboardingTopBar;
